import React from 'react'
import { HoverCard } from '@deal/components'
import IconTooltipWhite from './icon-tooltip-white.svg'
import IconTooltipBlack from './icon-tooltip-black.svg'
import styles from './styles.css'

interface TooltipProps {
  reference: string
  fill?: 'white' | 'black'
  place?: 'left' | 'right' | 'bottom' | 'top'
  title?: string
}

const ProductTooltip: React.SFC<TooltipProps> = ({
  reference,
  fill,
  place = 'right',
  title = ''
}) => {
  const tooltipMap: { [key: string]: string } = {
    flexType:
      'Affects distance, accuracy and trajectory of shot. Important to select proper flex in a club so clubface will be square on the ball when it makes contact.',
    regular:
      'Optimal for high handicap golfers able to drive a ball 210 to 250 yards off the tee. Regular flex shafts are the most popular choice for golfers with a swing speed between 85 and 95 mph.',
    senior:
      'Ideal for golfers who, with aging, have noticed a decline in their swing speed and drive distance. Senior flex shafts are generally suited for golfers with a swing between 75 and 85 mph with a carry distance of 180 to 210 yards.',
    stiff:
      'Best suited for mid-to-low handicap golfers able to drive a ball 250+ yards. They are typically used by golfers with a 95 to 110 mph swing.',
    extraStiff:
      'Golfers able to drive a ball 275+ yards with a swing speed of 110+ mph may prefer an extra stiff shaft. These can be challenging to find, as they are relatively unpopular amongst non-professionals.',
    ladies:
      'A good fit for golfers with a sub 180 yard carry distance and a swing of less than 75 mph. Women with a longer drive and faster swing may want to consider senior or regular flex clubs.'
  }

  if (!tooltipMap[reference]) {
    return null
  }

  let IconComponent = fill === 'white' ? IconTooltipWhite : IconTooltipBlack

  return (
    <HoverCard placement={place} message={tooltipMap[reference]} title={title}>
      <IconComponent className={styles.icon} />
    </HoverCard>
  )
}

export default ProductTooltip
